import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Dropdown } from "react-bootstrap";
import toast from "react-hot-toast";

const FeeAgreementStatusActionMenuItem = ({ currentId, isCurrent, label, status, updateStatus, isDisabled = false }) => {
    const onHandleClick = () => {
        if (!updateStatus || typeof (updateStatus) !== 'function') {
            console.log("not a function");
            return;
        }

        updateStatus()
            .then(
                _ => toast.success("Status updated."),
                error => toast.error(error?.data)
            );
    };

    return (
        <Dropdown.Item className="d-flex justify-content-between align-items-center" disabled={isDisabled} onClick={onHandleClick}>
            {label}
            {isCurrent && <FontAwesomeIcon
                icon="check"
                className="text-success ms-2"
            />}
        </Dropdown.Item>
    );
};

export default FeeAgreementStatusActionMenuItem;